export const initialLandingState = {
  pricingData: []
};
